import { render, staticRenderFns } from "./towmenu.vue?vue&type=template&id=5f08d9e2&scoped=true&"
import script from "./towmenu.vue?vue&type=script&lang=js&"
export * from "./towmenu.vue?vue&type=script&lang=js&"
import style0 from "./towmenu.vue?vue&type=style&index=0&id=5f08d9e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f08d9e2",
  null
  
)

export default component.exports